import type { SxProps, Theme } from '@mui/material';

export const styles = {
    card: (active: boolean): SxProps<Theme> => ({
        m: 0.5,
        p: 1,
        borderRadius: '8px',
        cursor: 'pointer',
        backgroundColor: active ? '#F0F7FF' : '#FFFFFF',
        border: active ? '1px solid #BBDBFB' : '1px solid #E2E8EE',
    }),
    headerRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        mb: 0.5,
    } as SxProps<Theme>,
    timestamp: {
        fontSize: '12px',
        color: 'grey.500',
        fontWeight: 400,
    } as SxProps<Theme>,
    total: {
        fontSize: '14px',
        color: 'grey.800',
        fontWeight: 400,
    } as SxProps<Theme>,
    yymc: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: '16px',
        color: '#141E25',
    } as SxProps<Theme>,
    details: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: '12px',
        color: '#69787F',
    } as SxProps<Theme>,
    location: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: '14px',
        color: '#69787F',
    } as SxProps<Theme>,
    divider: {
        width: '95%',
        my: 0.5,
        alignSelf: 'center',
    } as SxProps<Theme>,
    serviceRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        p: 0.25,
    } as SxProps<Theme>,
    repairerRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        p: 0.25,
        width: '100%',
        position: 'relative',
    } as SxProps<Theme>,
    starIcon: (theme: Theme) => ({
        ml: 0.5,
        color: theme.palette.grey[400],
        fontSize: '18px',
        position: 'absolute',
        right: '8px',
    }),
    statusContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
    } as SxProps<Theme>,
};
